import * as React from "react";
import { cn } from "lib/utils";

type DivProps = React.HTMLAttributes<HTMLDivElement>;

/** 화면 폭을 제한하지 않는 페이지 컨테이너 */
export const PageContainer = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      "w-full px-4 pt-5 pb-16 sm:px-6 lg:px-8 lg:pt-6",
      className
    )}
    {...props}
  />
);

/** 페이지 제목 + 설명 + 우측 액션 */
export const PageHeader = ({
  title,
  description,
  actions,
  className,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex flex-col gap-3 pb-4 sm:flex-row sm:items-start sm:justify-between",
      className
    )}
  >
    <div className="min-w-0">
      <h1 className="text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
        {title}
      </h1>
      {description && (
        <p className="pt-1 text-sm text-gray-500">{description}</p>
      )}
    </div>
    {actions && (
      <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
    )}
  </div>
);

/** 검색·필터 툴바 */
export const Toolbar = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      "flex flex-wrap items-center gap-x-4 gap-y-3 rounded-xl border border-gray-200 bg-gray-50/70 px-4 py-3 text-sm",
      className
    )}
    {...props}
  />
);

/** 표·차트를 담는 흰색 카드 */
export const SectionCard = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      "rounded-xl border border-gray-200 bg-white shadow-sm",
      className
    )}
    {...props}
  />
);

/** 입력 폼용 카드 (전체폭 셸 안에서 읽기 좋은 폭 유지) */
export const FormCard = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      "mx-auto w-full max-w-2xl rounded-xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8",
      className
    )}
    {...props}
  />
);
